import React from 'react'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { useParams } from 'react-router'
import { Col, Modal, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { WarningModalHeader } from 'components/ui/modals/WarningModalHeader'
import { translationPrefix } from './constants'
import { ButtonChangeToProgress } from './components'
import { ButtonKeep } from './components/ButtonKeep'

interface DeleteResultsProps {
  show: boolean
  onSuccess: () => void
  onClose: () => void
}

export const DeleteResults: React.FC<DeleteResultsProps> = ({
  show,
  onSuccess,
  onClose,
}) => {
  const t = useTranslationRankmi({
    prefix: translationPrefix,
  })
  const { courseId } = useParams<{
    courseId: string
  }>()

  return (
    <>
      <Modal show={show} size={'lg'} centered onHide={onClose}>
        <WarningModalHeader translate="yes" closeButton>
          <FontAwesomeIcon icon={faCog} />
          <h5 className="ml-2 mb-0">{t('title')}</h5>
        </WarningModalHeader>
        <Modal.Body className="px-4">
          <div className="mb-3">{t('description')}</div>
          <Row className="d-flex justify-content-center px-md-1">
            <Col xs={12} lg={4} className="mt-1">
              <ButtonChangeToProgress {...{ courseId, onSuccess }} />
            </Col>
            <Col xs={12} lg={4} className="mt-1">
              <ButtonKeep {...{ courseId, onSuccess }} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DeleteResults
